var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:`expand-btn ${
    !_vm.isOpen ? '' : 'v-icon-rotate'
  } d-inline-flex align-center`},[_c('v-icon',{class:`${_vm.center ? '' : 'mr-1 '}py-h `,attrs:{"small":""}},[_vm._v("$expand")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }